import React from 'react';
import { Box } from '@mui/material';
import { H4 } from '@tviklax/ui-components';

const TermsAndConditions: React.FC = () => {
    return (
        <Box>
            <H4 style={{ marginTop: '1.5rem', marginBottom: '2.5rem', fontWeight: 600 }}>
                Terms and Conditions for Sellers:
            </H4>

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                {[
                    {
                        title: "Keep Information Updated:",
                        text: "Sellers must maintain accurate details regarding inventory, stock, warehouses, and products."
                    },
                    {
                        title: "Order Fulfillment:",
                        text: "Orders must be processed and shipped within 24 hours of being placed."
                    },
                    {
                        title: "Packaging & Shipping:",
                        text: "Products should be packaged according to Tvikla's standards and shipped directly to customers using the provided shipping labels."
                    },
                    {
                        title: "Return Policy:",
                        text: "Sellers must clearly state their return policies.",
                        subItems: [
                            "Returns will be handled by Tvikla and stored in U.S. warehouses for resale if the product is in good condition.",
                            "Damaged or unsellable items will be scrapped."
                        ]
                    },
                    {
                        title: "Labeling Requirements:",
                        text: "Food products must have ingredients and compositions clearly printed, adhering to international standards. Products rejected by customs cannot be resold."
                    },
                    {
                        title: "Order Compliance:",
                        text: "Sellers who fail to fulfill orders more than three times will have their accounts placed on hold. Continued non-compliance may result in account removal."
                    }
                ].map((item, index) => (
                    <Box key={index} sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, mb: 2 }}>
                        <Box sx={{ minWidth: '20px', fontWeight: 500, fontSize: '18px', lineHeight: 1.5 }}>
                            {index + 1}.
                        </Box>
                        <Box>
                            <Box component="span" sx={{ fontWeight: 600, fontSize: '18px', color: 'black', mr: 1 }}>
                                {item.title}
                            </Box>
                            <Box component="span" sx={{ fontWeight: 500, fontSize: '18px' }}>
                                {item.text}
                            </Box>
                            {item.subItems && (
                                <ul style={{ listStyleType: 'disc', paddingLeft: '20px', marginTop: '8px', color: '#444', fontWeight: 500, fontSize: '18px' }}>
                                    {item.subItems.map((subItem, subIndex) => (
                                        <li key={subIndex}>{subItem}</li>
                                    ))}
                                </ul>
                            )}
                        </Box>
                    </Box>
                ))}
            </Box>
        </Box>
    );
};

export default TermsAndConditions;
